import { fetchIpDetails } from '../microservices/ip';
import { logger } from './logger';
import { stores } from '../stores';
import { isFeatureAvailable } from './feature';
import { FEATURE } from './types';
import { Country } from '@staycool/location';
import { isProd } from './environment';

export async function loadIpDetails() {
    if (!isFeatureAvailable(FEATURE.IP_CHECK)) {
        stores.ipCountry.set(Country.USA);
        if (isProd()) {
            return;
        }
        fetchIpDetails()
            .then(({ isOfficeIP }) => {
                stores.isOfficeIp.set(isOfficeIP);
            })
            .catch((error) => {
                logger.error('IpService', 'loadIpDetails', error);
            });
        return;
    }
    try {
        const { countryCode, query, isOfficeIP, regionName, lat, lon } = await fetchIpDetails();
        stores.ipCountry.set(countryCode || 'EN');
        stores.ipProvince.set(regionName || '');
        stores.ip.set(query);
        stores.ipLocation.set({ latitude: lat, longitude: lon });
        stores.isOfficeIp.set(Boolean(isOfficeIP));
    } catch (error) {
        logger.error('IpService', 'loadIpDetails', error);
    }
}
